@if (pfTitle) {
    <pf-text type="description">{{ pfTitle }}</pf-text>
}
<nz-segmented
    [nzOptions]="segmentedOptions"
    [(ngModel)]="model"
    (ngModelChange)="handleModelChange($event)"></nz-segmented>
